<template>
  <AppRadioGroup
    :disabled="disabled"
    :model-value="modelValue"
    :name="name"
    :options="options"
    :size="RADIO_GROUP_SIZES.XS"
    style="--fill: var(--grey-3-next); --option-padding: 0px 8px 0 4px"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #item-label="{ item }">
      <AppRadioGroupNextOptionWithIcon :gap="gap" :option="item" />
    </template>
  </AppRadioGroup>
</template>

<script setup>
import { RADIO_GROUP_SIZES } from '@/utils/components-configurations/app-radio-group'

import AppRadioGroup from '@/components/ui/AppRadioGroup/AppRadioGroup'
import AppRadioGroupNextOptionWithIcon from '@/components/ui/AppRadioGroup/AppRadioGroupNextOptionWithIcon'

defineOptions({
  name: 'AppRadioGroupCommon'
})

defineProps({
  modelValue: {
    type: [Number, Boolean, String],
    required: true
  },

  options: {
    type: Array,
    default: () => []
  },

  name: {
    type: String,
    default: ''
  },

  disabled: {
    type: Boolean
  },

  gap: {
    type: String,
    default: '4px'
  }
})
const emit = defineEmits(['update:modelValue'])
</script>
<style lang="scss" scoped></style>
